const floatOrNull = (value: any): number | null => {
  const parsedValue = parseFloat(value)

  return isNaN(parsedValue) ? null : parsedValue
}

export default floatOrNull
